<template id="forUse">
  <div v-if="canDisable" class="menu drp-dwn">
    <md-button class="btn-menu dropbtn disabledBtn md-sm" @click.prevent="notifyExportOverLimit()"><i class="fa fa-download fa-1 download-icon"></i> {{buttonName}}</md-button>
  </div>
  <div v-else class="menu drp-dwn">
    <a v-if="singleFormatDownload && enableLink" :id="`single-link-${itemIndex}`" href="javascript:void(0)" class="download-link" @click="downloadData()"><i v-if="iconRequired" class="fa fa-download fa-1 download-icon"></i> {{buttonName}}</a>

    <md-button v-if="singleFormatDownload && !enableLink" :id="`single-link-${itemIndex}`" :disabled="disabled" class="btn dropbtn md-sm" @click="downloadData()"><i v-if="iconRequired" class="fa fa-download fa-1 download-icon"></i> {{buttonName}}</md-button>

    <md-button v-if="!singleFormatDownload" class="btn-menu dropbtn md-sm" :disabled="disabled" @click="toggleMenu()"><i class="fa fa-download fa-1 download-icon"></i> {{buttonName}}</md-button>

    <div v-if="!singleFormatDownload" :id="`menu-items-${itemIndex}`" class="menu-content">
      <a v-for="(link, index) in downloadLinks" :key="`${link.reportFor}-${index}`" @click="exportData(link, object)" href="javascript:void(0)" class="dwn-link">
        <span class="drp-label">{{link.name}}</span>
      </a>
    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  import jsPDF from 'jspdf';
  import 'jspdf-autotable';
  import moment from "moment";
  import numeral from "numeral";
  import constants from "@/constants";
  import { groupBy,
          convertParamsToObject,
          readableText,
          profileFullName, getParamsByKey, elementCount, getAccountOfficers } from "@/lib/utils";

  export default {
    name: 'download-links-menu',
    props: {
      canDisable: {
        type: Boolean,
        default: false
      },
      selectedPayer: {
        type: Object,
        required: false,
      },
      downloadLinks: {
        type: Array,
        required: true,
      },
      buttonName: {
        type: String,
        default: "Download"
      },
      object:{
        type: Object
      },
      itemIndex: {
        type: Number,
        default: 0,
        required: false
      },
      revenues: {
        type: Array,
        default: () => []
      },
      agencies: {
        type: Array,
        default: () => []
      },
      enableLink: {
        type: Boolean,
        default: false
      },
      iconRequired: {
        type: Boolean,
        default: true
      },
      billCurrency: {
        type: String,
        default: "NGN"
      },
      allowDownload: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        perPageOnReport: 500,
        defaultTopMargin: 40,
        loader: {},
        reportFor: '',
        fileName: '',
        headerColumns: [],
        logoRequired: false,
        resultData: [],
        pdfStyles: {
          fontSizes: {
            verySmall: 8,
            small: 10,
            medium: 12,
            large: 14,
            veryLarge: 16,
            largest: 20
          },
          fontStyles: {
            normal: 'normal',
            bold: 'bold',
            italic: 'italic',
          },
          rmtDefaultColor: '#1C0080',
          columnStyles: {
            0: {cellWidth: 80},
            1: {cellWidth: 80},
            2: {cellWidth: 80},
            3: {cellWidth: 80},
            4: {cellWidth: 120}
          },
          rmtSubTabstyles: {
            cellPadding: 2,
            lineWidth: 0,
            valign:'middle',
            halign: 'left',
            fontSize: 10,
            fontStyle: 'italic',
            minCellHeight:12,
          },
          general: {
            cellPadding: 3,
            fontSize: 8,
            valign: 'middle',
            overflow: 'linebreak',
            tableWidth: 'auto',
            fillColor: '#e4e4e4',
            lineWidth: 0
          },
          header: {
            cellPadding: 2,
            lineWidth: 0,
            valign:'middle',
            fontStyle: 'bold',
            halign: 'left',
            fillColor: '#43a047',
            textColor: '#fff',
            fontSize: 10,
            minCellHeight:20
          }
        },
        logoPath: this.$constants.lirsHeader.logoPath,
        logoTitle: this.$constants.lirsHeader.title,
        address: this.$constants.lirsHeader.address
      }
    },

    computed: {
      singleFormatDownload() {
        return this.downloadLinks.length === 1;
      }
    },

    methods: {
      notifyExportOverLimit() {
        this.notification("Maximum of 1000 records can be exported at a time", "pan_tool", "danger");
      },

      getPaginationParams(currentPage) {
        return `page_size=${this.perPageOnReport}&page=${currentPage}`;
      },

      toggleMenu () {
        document.getElementById(`menu-items-${this.itemIndex}`).classList.toggle("show");
      },

      downloadData() {
        if (!this.allowDownload) {
          return
        }
        const linkData = this.downloadLinks[0];
        this.exportData(linkData, this.object);
      },

      debtSource(item) {
        if(item.assessments.length && item.bill) {
          return 'Assessments & Bill'
        } else if(item.assessments.length && !item.bill) {
          return 'Assessments'
        } else if(!item.assessments.length && item.bill) {
          return 'Bill'
        } else {
          return 'N/A'
        }
      },

      addLogo(doc) {
        const img = new Image();
        img.src = this.logoPath;
        doc.addImage(img, 'jpg', 380, 40, 75, 75);
        doc.setFontSize(this.pdfStyles.fontSizes.medium);
        doc.text(290, 140, this.logoTitle);
        doc.setFontSize(this.pdfStyles.fontSizes.small);
        doc.text(220, 160, this.address);
      },

      setPageTitle(doc, customTitle = "") {
        const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
        const pageTitle = customTitle ? customTitle : `${this.reportFor} REPORT`;
        doc.setTextColor('#43a047');
        doc.setFontSize(this.pdfStyles.fontSizes.large);
        doc.text(pageTitle, pageWidth / 2, 25, 'center');
      },

      generatePDF(titleText = "") {
        const headerColumns = this.headerColumns;
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'pt',
          format: 'a4'
        });

        this.setPageTitle(doc, titleText);
        if(this.logoRequired) {
          doc.setTextColor('#333');
          this.addLogo(doc);
        }
        doc.setTextColor('#43a047');
        const pdfColumns = [];
        for (let i=0; i < headerColumns.length - 1; i++) {
          pdfColumns.push(
            {title: headerColumns[i], dataKey: headerColumns[i]}
          );
        }

        const logoMargin = 180;
        const tableMargin = doc.pageCount > 1 ? this.defaultTopMargin : this.logoRequired ? logoMargin : this.defaultTopMargin;

        doc.autoTable({
          startY: tableMargin,
          columns: pdfColumns,
          body: this.resultData,
          styles: this.pdfStyles.general,
          headStyles: this.pdfStyles.header
        });
        doc.save(`${this.fileName}.pdf`);
        this.loader.hide();
      },

      generateExcel() {
        const reportsSheet = XLSX.utils.json_to_sheet(
          this.resultData,
        );
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, reportsSheet, 'revenue-reports');
        XLSX.writeFile(wb, `${this.fileName}.xlsx`);
        this.loader.hide();
      },

      generateDocs(data, link) {
        this.reportFor = link.reportFor;
        let headerColumns = [];
        const reportOf = `${this.reportFor.toLowerCase()}-reports`;
        const atMoment = moment().format('MMDYYYYhmmssA');
        this.fileName = `${reportOf}-${atMoment}`;
        switch(this.reportFor) {
          case 'REVENUE': {
            this.headerColumns = headerColumns = ['Created', 'Revenue Code/Name', 'Transaction Reference', 'Tax Payer', constants.identityLabels.ebs, 'Agency', 'Credit Amount', 'Debit Amount', 'Bank', 'Bank Acct', ''];
            this.resultData = data.map(function(item) {
              let itemObj = {};
              let orcRev =  `${item.orcRev ? item.orcRev + '/'  : ''} ${item.RevName}`
              itemObj[headerColumns[0]] = moment(item.EntryDate).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = orcRev;
              itemObj[headerColumns[2]] = item.TransRef;
              itemObj[headerColumns[3]] = item.cFullName === 'Payer Individual' ? item.nFullName : item.cFullName;
              itemObj[headerColumns[4]] = item.cFullName === 'Payer Individual' ? `N-${item.NonCorpID}` : `C-${item.PayerIDRef}`;
              itemObj[headerColumns[5]] = item.AgencyName;
              itemObj[headerColumns[6]] = numeral(item.CrAmount).format('0,0.00');
              itemObj[headerColumns[7]] = item.DrAmount;
              itemObj[headerColumns[8]] = item.ShortName;
              itemObj[headerColumns[9]] = item.BankAcct;
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'DEBTS': {
            this.headerColumns = headerColumns = [constants.identityLabels.ebs, 'Tax Payer Type', 'Agency', 'Revenue', 'Outstanding', 'Applied Period', 'Assessment Reference', 'Debt Source', 'Business Type', ''];
            const self = this;
            const processedData = this.debtProcessedData(data.list);
            this.resultData = processedData.map(function(item) {
              const isCorporate = item.tax_payer.entity && item.tax_payer.entity.business_type;
              const itemObj = {};
              itemObj[headerColumns[0]] = item.tax_payer.reg_no;
              itemObj[headerColumns[1]] = isCorporate ? 'Corporation' : 'Individual';
              itemObj[headerColumns[2]] = '-';
              itemObj[headerColumns[3]] = '-';
              if(item.bill && item.bill.agency_code) {
                itemObj[headerColumns[2]] = `${item.bill.agency_name} (${item.bill.agency_code})`;
              }
              if(item.bill && item.bill.revenue_code) {
                itemObj[headerColumns[3]] = `${item.bill.revenue_name} (${item.bill.revenue_code})`;
              }
              itemObj[headerColumns[4]] = numeral(item.total_debts).format('0,0.00');
              itemObj[headerColumns[5]] = item.duration;
              itemObj[headerColumns[6]] = item.reference;
              itemObj[headerColumns[7]] = self.debtSource(item);
              itemObj[headerColumns[8]] = '-';
              if(isCorporate) {
                itemObj[headerColumns[8]] = item.tax_payer.entity.business_type.name;
              }

              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'TAXAUDIT': {
            this.headerColumns = headerColumns = ['Created At', 'Reference', constants.identityLabels.ebs, 'Years', 'Status', 'Case Type', ''];
            this.resultData = data.list.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = moment(item.created_at).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = item.reference;
              itemObj[headerColumns[2]] = item.tax_payer ? item.tax_payer.reg_no : '-';
              itemObj[headerColumns[3]] = item.years.length > 1 ? `${item.years[0]} - ${item.years[1]}` : item.years[0];
              itemObj[headerColumns[4]] = item.status.name;
              itemObj[headerColumns[5]] = item.type.name ? item.type.name : '-';
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'ASSESSMENT': {
            headerColumns = ['Payer Name', 'Reference', constants.identityLabels.ebs, 'Region', 'Tax Station', 'Tax Due', 'Tax Outstanding', 'Status', 'Creator', 'Modified By', 'Created At', ''];
            let columnIndex = 5; // Inserting "Total Income" at 5th index for individual assesment reports OR "Tax Due" will remain 5th indexed item
            if(!link.isOfCorporateAssessments) {
              headerColumns.splice(columnIndex, 0, 'Total Income');
            }
            this.headerColumns = headerColumns;

            this.resultData = data.list.map(function(item) {
              columnIndex = 5; // Reseting total income column index as 5 for each row
              let itemObj = {};
              itemObj[headerColumns[0]] = profileFullName(item.tax_payer.entity) || item.tax_payer.entity.name;

              itemObj[headerColumns[1]] = item.reference;
              itemObj[headerColumns[2]] = item.tax_payer ? item.tax_payer.reg_no : '-';
              itemObj[headerColumns[3]] = (
                item.tax_payer &&
                item.tax_payer.preferred_tax_office &&
                item.tax_payer.preferred_tax_office.region) ?
                item.tax_payer.preferred_tax_office.region.name :
                '-';
              itemObj[headerColumns[4]] = (
                item.tax_payer &&
                item.tax_payer.preferred_tax_office) ? item.tax_payer.preferred_tax_office.name : '-';

              let totalIncome = 0;
              let taxDue = 0;
              let taxOutstanding = 0;
              if (item.direct_assessments) {
                item.direct_assessments.forEach(ass => {
                  if (ass.total_income) {
                    totalIncome += parseFloat(ass.total_income);
                  }
                  if (ass.net_payable) {
                    taxDue += parseFloat(ass.net_payable);
                  }

                  if (ass.total_outstanding) {
                    taxOutstanding += parseFloat(ass.total_outstanding);
                  }
                });
                itemObj[headerColumns[columnIndex]] = numeral(totalIncome).format('0,0.00');
                columnIndex += 1;
                itemObj[headerColumns[columnIndex]] = numeral(taxDue).format('0,0.00');
                columnIndex += 1;
                itemObj[headerColumns[columnIndex]] = numeral(taxOutstanding).format('0,0.00');
              }

              if (item.assessments) {
                item.assessments.forEach(ass => {
                  if (ass.total_taxable) {
                    taxDue += parseFloat(ass.total_taxable);
                  }
                });
                itemObj[headerColumns[columnIndex]] = numeral(taxDue).format('0,0.00');
              }

              itemObj[headerColumns[columnIndex + 1]] = item.status.label;
              itemObj[headerColumns[columnIndex + 2]] = `${item.creator.first_name} ${item.creator.last_name}`;
              itemObj[headerColumns[columnIndex + 3]] = `${item.last_updated_by.first_name} ${item.last_updated_by.last_name}`;
              itemObj[headerColumns[columnIndex + 4]] = moment(item.created_at).format('DD MMM YYYY');
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'RETURNS': {
            const filterParams = getParamsByKey(this.downloadLinks[0].params, 'filters');
            const individualTypeId = 1;

            const isOfIndividual = filterParams.find(params => params.field === "taxPayer.entity_type_id" && params.value === individualTypeId);

            headerColumns = ['Created At', constants.identityLabels.ebs, 'Full Name', 'Gross Income', 'Year', 'Tax Station', ''];

            if(isOfIndividual) {
              this.logoRequired = true;
              headerColumns.splice(4, 0, "Address", "Total Expenses");
            }
            this.headerColumns = headerColumns;
            this.resultData = data.list.map(function(item) {
              if(!isOfIndividual) {
                const annualItems = item.annual.map(pr => pr['gross_income']);
                const grossAnnual = elementCount(annualItems);
                item.gross_annual_income = grossAnnual;
              }

              let itemObj = {};
              itemObj[headerColumns[0]] = moment(item.created_at).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = item.tax_payer ? item.tax_payer.reg_no : '-';
              itemObj[headerColumns[2]] = item.tax_payer ? (item.tax_payer.individual ? profileFullName(item.tax_payer.individual) : item.tax_payer.entity.name) : "";
              itemObj[headerColumns[3]] = numeral(isOfIndividual ? item.total_income : item.gross_annual_income).format('0,0.00');

              if(isOfIndividual) {
                itemObj[headerColumns[headerColumns.indexOf('Address')]] = item.tax_payer && item.tax_payer.individual && item.tax_payer.individual.addresses && item.tax_payer.individual.addresses.length && item.tax_payer.individual.addresses[0].address;
                itemObj[headerColumns[headerColumns.indexOf('Total Expenses')]] = numeral(item.total_expense).format('0,0.00');
              }
              itemObj[headerColumns[headerColumns.indexOf('Year')]] = item.year;
              const office = item.tax_payer && item.tax_payer.preferred_tax_office && item.tax_payer.preferred_tax_office.name;
              itemObj[headerColumns[headerColumns.indexOf('Tax Station')]] = office;
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'INDIVIDUAL TAX PAYERS': {
            this.headerColumns = headerColumns = ['Created At', constants.identityLabels.ebs, 'Tax Payer Name', 'Tax Station', constants.identityLabels.tin, constants.identityLabels.jrb, ''];
            this.resultData = data.list.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = moment(item.created_at).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = item.tax_payer ? item.tax_payer.reg_no : '-';
              itemObj[headerColumns[2]] = `${item.title && item.title.name} . ${item.first_name} ${item.last_name}`;
              itemObj[headerColumns[3]] = (
                item.tax_payer &&
                item.tax_payer.preferred_tax_office) ? item.tax_payer.preferred_tax_office.name : '-';
                itemObj[headerColumns[4]] = (item.tax_payer && item.tax_payer.tin_number) ? item.tax_payer.tin_number : '-';
                itemObj[headerColumns[5]] = (item.tax_payer && item.tax_payer.jrb_number) ? item.tax_payer.jrb_number : '-';
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'CORPORATE TAX PAYERS': {
            this.headerColumns = headerColumns = ['Created At', constants.identityLabels.ebs, 'Tax Payer Name', 'Creator Id',  'Creator Name', 'Creator User Type', 'Tax Station', 'CAC Reg No.', constants.identityLabels.tin, constants.identityLabels.jrb, ''];
            this.resultData = data.list.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = moment(item.created_at).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = item.tax_payer ? item.tax_payer.reg_no : '-';
              itemObj[headerColumns[2]] = item.name;
              itemObj[headerColumns[3]] = item.tax_payer.creator ? item.tax_payer.creator.reg_no : "-";
              itemObj[headerColumns[4]] = item.tax_payer.creator ? (item.tax_payer.creator.first_name + " " + item.tax_payer.creator.last_name) : item.name;
              itemObj[headerColumns[5]] = item.tax_payer.creator_type_object ? item.tax_payer.creator_type_object.label : item.tax_payer.is_legacy  === 1 ? 'LEGACY' : 'Taxpayer';
              itemObj[headerColumns[6]] = (
                item.tax_payer &&
                item.tax_payer.preferred_tax_office) ? item.tax_payer.preferred_tax_office.name : '-';
              itemObj[headerColumns[7]] = item.identification_number || '-';
              itemObj[headerColumns[8]] = (item.tax_payer && item.tax_payer.tin_number) ? item.tax_payer.tin_number : '-';
              itemObj[headerColumns[9]] = (item.tax_payer && item.tax_payer.jrb_number) ? item.tax_payer.jrb_number : '-';
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'BILL SLIP': {
            let currency = this.billCurrency;
            this.logoRequired = true;
            this.headerColumns = headerColumns = ['Bill Reference', constants.identityLabels.ebs, 'Tax Payer Name', 'Agency', 'Revenue', 'Payment Period X', 'Bill Amount', 'Amount Paid', 'Outstanding Bill', 'Date', ''];
            this.resultData = data.list.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = item.system_reference;
              itemObj[headerColumns[1]] = item.tax_payer ? item.tax_payer.reg_no : '-';
              itemObj[headerColumns[2]] = item.tax_payer && item.tax_payer.entity ? (profileFullName(item.tax_payer.entity) || item.tax_payer.entity.name) : '';
              itemObj[headerColumns[3]] = `${item.agency_code} ${item.agency_name}`;
              itemObj[headerColumns[4]] = `${item.revenue_code} ${item.revenue_name}`;
              itemObj[headerColumns[5]] = item.revenue_code === constants.codeRevenuePaye ? moment(item.start_date).format('DD/MMM/YYYY').toUpperCase() : `${moment(item.start_date).format('DD/MMM/YYYY').toUpperCase()} To ${moment(item.end_date).format('DD/MMM/YYYY').toUpperCase()}`;
              itemObj[headerColumns[6]] = currency + ' ' + numeral(item.amount_due).format('0,0.00');
              itemObj[headerColumns[7]] = currency + ' ' + numeral(item.amount_paid).format('0,0.00');
              itemObj[headerColumns[8]] = currency + ' ' + numeral(item.amount_due - item.amount_paid).format('0,0.00');
              itemObj[headerColumns[9]] = moment(item.created_at).format('DD MMM YYYY');

              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'DIRECTORS': {
            this.headerColumns = headerColumns = [constants.identityLabels.ebs, 'Tax Payer Name', 'Email', 'Phone Number', 'Tax Station', `Relation ${constants.identityLabels.ebs}`, 'Relation Payer Name', 'Created At', ''];
            this.resultData = data.list.map(function(item) {
              let itemObj = {};
              const relationTaxPayerEntity = item.relation_tax_payer.entity;
              itemObj[headerColumns[0]] = item.relation_tax_payer.reg_no;
              itemObj[headerColumns[1]] = `${relationTaxPayerEntity && relationTaxPayerEntity.title && relationTaxPayerEntity.title.name}. ${profileFullName(item.relation_tax_payer.entity) || item.relation_tax_payer.entity.name}`;
              itemObj[headerColumns[2]] = relationTaxPayerEntity && item.relation_tax_payer.entity.email;
              itemObj[headerColumns[3]] = relationTaxPayerEntity && item.relation_tax_payer.entity.telephone;
              itemObj[headerColumns[4]] = item.relation_tax_payer.preferred_tax_office && item.relation_tax_payer.preferred_tax_office.name;
              itemObj[headerColumns[5]] = item.tax_payer.reg_no;
              itemObj[headerColumns[6]] = profileFullName(item.tax_payer.entity) || item.tax_payer.entity.name;
              itemObj[headerColumns[7]] = moment(item.created_at).format('DD MMM YYYY');
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'REMITTANCE_STATEMENT': {
            const dataByRevCode = groupBy(data, 'RevCode', 'RevName');
            this.headerColumns = [
              'Trans Date',
              'Base CCY',
              'Actual Amt',
              'Convt Amt',
              'Details'
            ];
            this.generateRemittanceStatement(dataByRevCode);
            break;
          }
          case 'TAX PAYER TAX RECORDS': {
            this.headerColumns = headerColumns = [
              'Payment Year',
              'Gross Earnings',
              'Tax Payable',
              'Tax Paid',
              'Period Paid',
              'Certified On',
              'Certified By',
              ''
            ];
            this.resultData = data.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = item.TaxYear;
              itemObj[headerColumns[1]] = item.GrossEarnings;
              itemObj[headerColumns[2]] = item.TaxPayable;
              itemObj[headerColumns[3]] = item.TaxPaid;
              itemObj[headerColumns[4]] = item.TaxYear;
              itemObj[headerColumns[5]] = item.CertifiedOn;
              itemObj[headerColumns[6]] = item.CertifiedBy;

              return itemObj;
            });
            this.generateTaxDetails(link);
            break;
          }
          case 'AUDIT': {
            const auditItems = data.list;
            this.headerColumns = headerColumns = ['Action On', 'Action', 'Performed By', 'Role', 'Tax Office', 'Phone', 'Email', 'Date & Time', ''];
            this.resultData = auditItems.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = `${item.pretty.entity_type} ${item.pretty.entity_reference}`;
              itemObj[headerColumns[1]] = item.pretty.action;
              itemObj[headerColumns[2]] = item.pretty.actor;
              itemObj[headerColumns[3]] = item.pretty.actor_type;
              itemObj[headerColumns[4]] = item.pretty.actor_office;
              itemObj[headerColumns[5]] = item.pretty.actor_telephone;
              itemObj[headerColumns[6]] = item.pretty.actor_email;
              itemObj[headerColumns[7]] = moment(item.done_at).format('DD MMM YYYY - HH:MM');
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }
          case 'AUDIT_DETAIL': {
            const auditDetail = data.list[0];
            this.headerColumns = ['Property', 'Previous Value', 'Current Value', ''];
            const action = auditDetail.pretty.action === 'Creation' ? 'created' : auditDetail.pretty.action === 'Deletion' ? 'deleted' : 'updated';
            const titleText = `${auditDetail.pretty.actor} ${action} beolow details on ${moment(auditDetail.pretty.done_at).format('DD MMM YYYY - HH:MM')}`;

            this.fetchAuditData(auditDetail);
            this.generatePDF(titleText);
            break;
          }
          case 'RMU REVENUE': {
            this.headerColumns = headerColumns = [constants.identityLabels.ebs, 'Company Name', 'Email', 'Business Sector', 'Account Officers', 'Bill Reference', 'Applied Month', 'Gross Income', 'Tax Payable', 'Tax Paid', ''];

            this.resultData = data.list.map(function(item) {
              const itemObj = {};
              const payerEntity = item.tax_payer && item.tax_payer.entity;
              itemObj[headerColumns[0]] = item.tax_payer.reg_no;
              itemObj[headerColumns[1]] = payerEntity && payerEntity.name;
              itemObj[headerColumns[2]] = payerEntity && payerEntity.email;
              itemObj[headerColumns[3]] = payerEntity && payerEntity.business_type.name;
              itemObj[headerColumns[4]] = getAccountOfficers(item);
              itemObj[headerColumns[5]] = item.system_reference;
              itemObj[headerColumns[6]] = moment(item.created_at).format('MMM YYYY');
              itemObj[headerColumns[7]] = numeral(item.total_gross_income).format('0,0.00');
              itemObj[headerColumns[8]] = numeral(item.amount_due).format('0,0.00');
              itemObj[headerColumns[9]] = numeral(item.amount_paid).format('0,0.00');
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'EBS TRANSACTIONS': {
            this.headerColumns = headerColumns = ['Created', 'Transaction Reference', 'Tax Payer', constants.identityLabels.ebs, 'Revenue', 'Agency', 'Bank', 'Bank Acct', 'Branch Name', 'Acct Type', 'Credit Amount', 'Applied Date', ''];
            this.resultData = data.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = moment(item.EntryDate).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = item.TransRef;
              itemObj[headerColumns[2]] = item.cFullName === 'Payer Individual' ? item.nFullName : item.cFullName;
              itemObj[headerColumns[3]] = item.cFullName === 'Payer Individual' ? `N-${item.NonCorpID}` : `C-${item.PayerIDRef}`;
              itemObj[headerColumns[4]] = `${item.RevName} - ${item.orcRev}`;
              itemObj[headerColumns[5]] = `${item.AgencyName} - ${item.orcAg}`;
              itemObj[headerColumns[6]] = item.ShortName;
              itemObj[headerColumns[7]] = item.BankAcct;
              itemObj[headerColumns[8]] = item.BranchName;
              itemObj[headerColumns[9]] = item.AcctType;
              itemObj[headerColumns[10]] = numeral(item.CrAmount).format('0,0.00');
              itemObj[headerColumns[11]] = item.AppliedDate;
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'EBS EXPATRIATES': {
            this.headerColumns = headerColumns = ['Created', 'Assessment Reference', 'Tax Payer', constants.identityLabels.ebs, 'Nationality', 'Revenue', 'Agency', 'Bank Transaction ID', 'Bank Amount', 'Applied Date', ''];
            this.resultData = data.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = moment(item.BankEntryDate).format('DD MMM YYYY');
              itemObj[headerColumns[1]] = item.AssessRef;
              itemObj[headerColumns[2]] = item.FullName;
              itemObj[headerColumns[3]] = `${item.PayerType.trim()}-${item.PayerID}`;
              itemObj[headerColumns[4]] = item.Nationality;
              itemObj[headerColumns[5]] = item.RevCode.trim();
              itemObj[headerColumns[6]] = item.AgencyRef.trim();
              itemObj[headerColumns[7]] = item.BankTransID;
              itemObj[headerColumns[8]] = item.BankAmount;
              itemObj[headerColumns[9]] = item.AppliedDate;
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'EBS TRENDS COLLECTION': {
            this.headerColumns = headerColumns = ['Start Date', 'Agency', 'Revenue', 'Bank', 'P 0', 'P 1', 'P 2', 'P 3', 'P 4', 'Total', ''];
            this.resultData = data.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = item.StartDate;
              itemObj[headerColumns[1]] = `${item.RevName} - ${item.RevCode}`;
              itemObj[headerColumns[2]] = `${item.AgencyName} - ${item.AgencyRef}`;
              itemObj[headerColumns[3]] = item.ShortName;
              itemObj[headerColumns[4]] = numeral(item.p0).format('0,0.00');
              itemObj[headerColumns[5]] = numeral(item.p1).format('0,0.00');
              itemObj[headerColumns[6]] = numeral(item.p2).format('0,0.00');
              itemObj[headerColumns[7]] = numeral(item.p3).format('0,0.00');
              itemObj[headerColumns[8]] = numeral(item.p4).format('0,0.00');
              itemObj[headerColumns[9]] = numeral(item.Total).format('0,0.00');
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'OBJECTIONS': {
            this.headerColumns = headerColumns = ['Objection Ref', 'Tax Audit Case Ref', 'Payer ID', 'Title', 'Amount Proposed', 'Amount Requested', 'Created At', 'Objection Age', 'Last Modified At', 'Status', ''];
            
            this.resultData = data.list.map(function(item) {
              let itemObj = {};
              itemObj[headerColumns[0]] = item.reference;
              itemObj[headerColumns[1]] = item.assessment_group && item.assessment_group.tax_audit_id ? item.assessment_group.tax_audit.reference : 'N/A';
              itemObj[headerColumns[2]] = item.assessment_group.tax_payer ? item.assessment_group.tax_payer.reg_no : 'N/A';
              itemObj[headerColumns[3]] = item.name;
              itemObj[headerColumns[4]] = numeral(item.amount_suggested).format('0,0.00');
              itemObj[headerColumns[5]] = numeral(item.amount_requested).format('0,0.00');
              itemObj[headerColumns[6]] = moment(item.created_at).format('DD MMM YYYY');
              itemObj[headerColumns[7]] = `${item.age} Day(s)`;
              itemObj[headerColumns[8]] = moment(item.modified_at).format('DD MMM YYYY');
              itemObj[headerColumns[9]] = item.status && item.status.label;
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          case 'TAMA_JOB_REQUESTS': {
            this.headerColumns = headerColumns = ['TAMA ID', 'TAMA Name', 'Principal Partner', 'Date of Submission', 'Year of Allocation', 'Company Name', 'Company Address', 'CAC Number', 'Job Request ID', ''];
            const dataList = data && data.list;
            this.resultData = dataList.map(function(item) {
              let itemObj = {};
              const consultant = item.consultant && item.consultant.tax_payer
              const principalUser = item.consultant && item.consultant.principal_user;
              itemObj[headerColumns[0]] = consultant.reg_no;
              itemObj[headerColumns[1]] = profileFullName(consultant.entity);
              itemObj[headerColumns[2]] = principalUser && principalUser.tax_payer ? `${principalUser.tax_payer.reg_no}(${profileFullName(principalUser.tax_payer.entity)})` : 'N/A';
              itemObj[headerColumns[3]] = moment(item.created_at).format('MMM YYYY');
              itemObj[headerColumns[4]] = item.year;
              itemObj[headerColumns[5]] = item.company_name;
              itemObj[headerColumns[6]] = item.company_address;
              itemObj[headerColumns[7]] = item.company_cac_number;
              itemObj[headerColumns[8]] = item.reference;
              return itemObj;
            });
            link.name === "Excel" ? this.generateExcel() : this.generatePDF();
            break;
          }

          default: {
            // default block comes here
          }
        }
      },

      fetchAuditData(data) {
        const prevData = data.pretty.previous_data;
        const currentData = data.pretty.current_data;
        const dataKeys = Object.keys(currentData);
        this.resultData = [];
        dataKeys.forEach(item => {
          this.resultData.push({
            "Property": readableText(item),
            "Previous Value": (prevData && prevData[item] || 'N/A'),
            "Current Value": currentData[item] || 'N/A'
          })
        });
      },

      generateRmtHeader(doc) {
        // Left Header
        const defaultTextColor = this.pdfStyles.rmtDefaultColor;
        doc.setTextColor(defaultTextColor);
        const img = new Image();
        img.src = '/img/lagossu.png';
        doc.addImage(img, 'png', 50, 50, 75, 75);
        doc.setFontSize(this.pdfStyles.fontSizes.largest);
        doc.text(170, 50, 'Lagos State Government');
        doc.setFontSize(this.pdfStyles.fontSizes.veryLarge);
        doc.text(190, 70, 'Electronic Banking System');
        doc.text(270, 90, 'of');
        doc.text(190, 110, 'Revenue Cycle Management');
        doc.setTextColor(255,0,0); //Apply Red Color
        doc.text(170, 130, 'Individual Customer Statement');

        // Left Header - Profile Info
        doc.setTextColor(defaultTextColor);
        doc.setFontSize(this.pdfStyles.fontSizes.large);
        doc.setFont(this.pdfStyles.fontStyles.italic);

        let payerProfileName = "";
        const isCorporatePayerSelected = this.selectedPayer && this.selectedPayer.tax_payer.entity_type_id === 2
        if(isCorporatePayerSelected) {
          payerProfileName = `${this.selectedPayer.name}`;
          doc.text(45, 160, `${payerProfileName} <${this.selectedPayer.tax_payer.reg_no}>`);

          doc.text(45, 185, this.selectedPayer.addresses && this.selectedPayer.addresses[0] && this.selectedPayer.addresses[0].address);
        } else {
          payerProfileName = `${this.selectedPayer.title.name}. ${profileFullName(this.selectedPayer)}`;
          doc.text(45, 160, `${payerProfileName} <${this.selectedPayer.tax_payer.reg_no}>`);

          doc.text(45, 185, this.selectedPayer.address && this.selectedPayer.address.address);
        }

        const filterParams = convertParamsToObject(this.downloadLinks[0].params);
        const startDate = moment(filterParams.start_date).format('DD MMM YYYY');
        const endDate = moment(filterParams.end_date).format('DD MMM YYYY');
        doc.text(45, 220, `Remittance Statement for ${startDate} to ${endDate}`);
        doc.setLineWidth(1.5);
        doc.setDrawColor(defaultTextColor);
        doc.line(45, 225, 385, 225);

        // Right Header
        doc.setTextColor(defaultTextColor);
        doc.setFontSize(this.pdfStyles.fontSizes.large);
        doc.setFont(this.pdfStyles.fontStyles.bold);
        doc.text(530, 50, 'Board of Internal Revenue');
        doc.setFont(this.pdfStyles.fontStyles.normal);
        doc.text(530, 80, 'The Good Shepherd House, Alausa, Ikeja');
        doc.setFont(this.pdfStyles.fontStyles.italic);
        doc.setFontSize(this.pdfStyles.fontSizes.medium);
        const today = moment().format('dddd, MMMM DD, YYYY');
        doc.text(530, 110, today);

        // Few more details for corporate user
        if(isCorporatePayerSelected) {
          doc.rect(460, 125, 330, 60);
          doc.setFontSize(this.pdfStyles.fontSizes.large);
          doc.text(470, 145, `RC NO: ${this.selectedPayer.identification_number || ''}`);
          doc.setFontSize(this.pdfStyles.fontSizes.medium);
          doc.text(650, 145, `Incorpn Date: ${this.selectedPayer.incorporation_date || ''}`);
          doc.text(470, 175, `Industry: ${(this.selectedPayer.business_type && this.selectedPayer.business_type.name) || ''}`);
          doc.text(650, 175, `File Ref: ${this.selectedPayer.file_reference || ''}`);
        }
      },

      headerRmtTable(doc) {
        const headerStyle = this.pdfStyles.header;
        headerStyle.fontStyle = this.pdfStyles.fontStyles.normal;
        headerStyle.textColor = this.pdfStyles.rmtDefaultColor;
        headerStyle.fontSize = this.pdfStyles.fontSizes.medium;
        doc.setLineWidth(1);
        doc.line(40, 235, 800, 235);
        const tableHeader = this.headerColumns.reduce(function(acc, cur) {
          acc['"'+cur+'"'] = cur;
          return acc;
        }, {});
        doc.autoTable({
          margin: {
            top: 240
          },
          body: new Array(tableHeader),
          columnStyles: this.pdfStyles.columnStyles,
          styles: headerStyle
        });
        doc.line(40, 265, 800, 265);
      },

      generateRemittanceStatement(data) {
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'pt',
          format: 'a4'
        });

        // Head summary
        this.generateRmtHeader(doc);
        // Table Data - Header Table
        this.headerRmtTable(doc);

        const revKeys = Object.keys(data);
        let self = this;
        revKeys.forEach(function(rKey) {
          // Table with Group Name(Rev Code&Name)
          self.pdfStyles.rmtSubTabstyles.textColor = self.pdfStyles.rmtDefaultColor;
          self.pdfStyles.rmtSubTabstyles.fontSize = self.pdfStyles.fontSizes.small;

          doc.autoTable({
            body: [{'Trans Date': `Rev Code >> ${rKey}`}],
            styles: self.pdfStyles.rmtSubTabstyles,
            columnStyles: {
              0: {cellWidth: 100}
            },
            didParseCell: function (data) {
              const rows = data.table.body;
              if (data.row.index === rows.length - 1) {
                data.cell.styles.fillColor = ['#cfcade'];
                data.cell.styles.cellPadding = 5;
              }
            }
          });

          // Main Data Table
          const headerColumns = self.headerColumns;
          let reqData = data[rKey].map(function(item) {
            let itemObj = {};
            const detail = `taxPmt>>${moment(item.EntryDate).format('DD-MM-YYYY')}>${item.AgencyName}>${item.Ref}>${item.RevCode}/${item.ShortName} / (${item.CBNCode}) AssessRef: ${item.AssessRef}`
            itemObj[headerColumns[0]] = moment(item.EntryDate).format('DD MMM YYYY');
            itemObj[headerColumns[1]] = item['BaseCCY'];
            itemObj[headerColumns[2]] = item['ActualAmount'];
            itemObj[headerColumns[3]] = item['AmountLCY'];
            itemObj[headerColumns[4]] = detail;
            return itemObj;
          });

          doc.autoTable({
            body: reqData,
            styles: self.pdfStyles.general,
            columnStyles: self.pdfStyles.columnStyles,
            didParseCell: function (data) {
              if (data.row.index % 2 === 0) {
                data.cell.styles.fillColor = ['#ccc'];
                data.cell.styles.cellPadding = 5;
              }
            }
          });

          // Bottom Table of the group with summary
          const actualAmttotal = data[rKey].length === 1 ? parseFloat(data[rKey][0]['ActualAmount']) : data[rKey].reduce( ( sum, { ActualAmount } ) => sum + parseFloat(ActualAmount) , 0);
          const grandTotal = data[rKey].length === 1 ? parseFloat(data[rKey][0]['AmountLCY']) : data[rKey].reduce( ( sum, { AmountLCY } ) => sum + parseFloat(AmountLCY) , 0);

          self.pdfStyles.rmtSubTabstyles.textColor = '#333';
          self.pdfStyles.rmtSubTabstyles.fontSize = self.pdfStyles.fontSizes.verySmall;
          const summaryTableData = [
            {
              'Trans Date': `Summary for 'RevCodeRef' =  ${rKey} (${data[rKey].length} detail records)`,
              'Base CCY': ''
            },
            {
              'Trans Date': 'Sum',
              'Base CCY': actualAmttotal.toFixed(2)
            },
            {
              'Trans Date': 'Grand Total',
              'Base CCY': grandTotal.toFixed(2)
            },
          ];
          doc.autoTable({
            body: summaryTableData,
            styles: self.pdfStyles.rmtSubTabstyles,
            columnStyles: {
              0: {cellWidth: 100},
              1: {cellWidth: 100}
            }
          });
        })
        doc.save(`${this.fileName}.pdf`);
        this.loader.hide();
      },

      taxDetailsHeader(doc, link) {
        // Tax Details Card [Filters information here]
        const today = moment().format('DD/MM/YYYY');
        const filterParams = convertParamsToObject(link.params);
        const startYear = moment(filterParams.start_date).format('YYYY');
        const endYear = moment(filterParams.end_date).format('YYYY');

        doc.setTextColor('#000');
        doc.setFontSize(this.pdfStyles.fontSizes.medium);
        doc.text(50, 50, today);
        doc.text(400, 50, 'Lagos');
        doc.rect(75, 80, 700, 270);
        doc.setFontSize(this.pdfStyles.fontSizes.veryLarge);
        doc.setFont(this.pdfStyles.fontStyles.bold);
        doc.text(80, 110, `TAX CARD DETAILS`);
        doc.line(75, 125, 775, 125);
        doc.setFont(this.pdfStyles.fontStyles.normal);
        doc.setFontSize(this.pdfStyles.fontSizes.veryLarge);
        doc.text(80, 160, `Enter ${constants.identityLabels.ebs}: ${filterParams.tax_payer_id}`);
        doc.text(80, 200, `Start Year`);
        doc.text(170, 200, startYear);
        doc.text(230, 200, `End Year`);
        doc.text(310, 200, endYear);
        doc.setTextColor('#aaa');
        doc.text(80, 250, `Search`);
        doc.text(150, 250, `Back to main menu`);
        doc.setTextColor('#000');
        doc.line(75, 290, 775, 290);
        doc.text(80, 325, `For further clarifications call 01-7613108 or 01-7736399`);
        doc.line(50, 360, 800, 360);
      },

      profileDetailsInTaxReports(doc, link) {
        // Profile Information here
        const today = moment().format('DD/MM/YYYY');
        const filterParams = convertParamsToObject(link.params);
        doc.rect(75, 370, 700, 50);
        doc.setFontSize(this.pdfStyles.fontSizes.veryLarge);
        doc.setFont(this.pdfStyles.fontStyles.bold);
        doc.text(80, 400, `INFORMATION DETAILS`);
        doc.autoTable({
          margin: {
            top: 410
          }
        })
        let payerProfileName = "";
        let payerAddress = "";
        const isCorporatePayerSelected = this.selectedPayer && this.selectedPayer.tax_payer.entity_type_id === 2
        if(isCorporatePayerSelected) {
          payerProfileName = `${this.selectedPayer.name}`;
          payerAddress = this.selectedPayer.addresses && this.selectedPayer.addresses[0] && this.selectedPayer.addresses[0].address;
        } else {
          payerProfileName = `${this.selectedPayer.title.name}. ${profileFullName(this.selectedPayer)}`;
          payerAddress = this.selectedPayer.address && this.selectedPayer.address.address;
        }
        let item = {
          [constants.identityLabels.ebs] : filterParams.tax_payer_id,
          "Full Name" : payerProfileName,
          "Address" : payerAddress
        };
        if(isCorporatePayerSelected) {
          item["Corporate ID"] = this.selectedPayer.business_type && this.selectedPayer.business_type.name;
        } else {
          item["Date of Birth"] = this.selectedPayer.dob;
          item["Sex"] = this.selectedPayer.gender === 'female' ? 'F' : 'M';
          item["Nationality"] = this.selectedPayer.nationality && this.selectedPayer.nationality.name;
        }
        item["Printed Date"] = today;

        let rows = [];
        for(let key in item){
          let temp = [key, item[key]];
          rows.push(temp);
        }
        doc.autoTable({
          theme : 'grid',
          margin: {
            left: 75,
            right: 70
          },
          body: rows,
          styles: {
            fontSize: 14,
            cellPadding: 10,
            textColor: '#000'
          }
        });
      },

      generateTaxDetails(link) {
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'pt',
          format: 'a4'
        });

        this.taxDetailsHeader(doc, link);
        this.profileDetailsInTaxReports(doc, link);

        // Tax Reports Information here
        doc.autoTable({
          theme: 'grid',
          margin: {
            left: 75,
            right: 70
          },
          body: [{'title': 'CURRENT TAX CERTIFICATE RECORDS'}],
          styles: {
            fontSize: 16,
            cellPadding: 10,
            textColor: '#000',
            fontWeight: 'bold'
          }
        })

        let tableColumns = [];
        for (let i=0; i < this.headerColumns.length - 1; i++) {
          tableColumns.push(
            {title: this.headerColumns[i], dataKey: this.headerColumns[i]}
          );
        }
        doc.autoTable({
          theme: 'grid',
          margin: {
            left: 75,
            right: 70
          },
          columns: tableColumns,
          body: this.resultData,
          styles: {
            fontSize: 14,
            cellPadding: 6,
            textColor: '#000',
          }
        });

        doc.save(`${this.fileName}.pdf`);
        this.loader.hide();
      },

      async exportData(link, object = "") {
        if (!this.allowDownload) {
          return
        }
        if(!object && (!link || !link.url)) {
          this.notification("No data available to download", "pan_tool", "danger");
          return;
        }
        this.loader = this.$loading.show();
        if(Object.keys(object).length) {
          const data = {
            list: [
              object
            ]
          };
          this.generateDocs(data, link);
        } else {
          if(link.noOfPages) {
            const allRecords = {
              list: []
            };
            const reqPromises = [];
            for(let i = 0; i < link.noOfPages; i++) {
              // Create Promise for each chunck
              const promiseChunk = new Promise((resolve, reject) => {
                this.$http
                .post(link.url, {
                  method: link.method,
                  params: `${link.params}&${this.getPaginationParams(i+1)}`
                })
                .then(
                  response => {
                    if (response.data) {
                      if(i === 0) {
                        if (response.data.error) {
                          reject(false);
                          this.loader.hide();
                          this._handleErrors(response.data);
                        } else {
                          const dataOnReq = response.data;
                          const recordsExist = (Array.isArray(dataOnReq) && dataOnReq.length)
                              || (Object.keys(dataOnReq).length && dataOnReq.list && dataOnReq.list.length);
                          if (!recordsExist){
                            this.loader.hide();
                            return this.notification(
                              "No records found matching the selected filters",
                              "pan_tool",
                              "danger"
                            );
                          }
                          resolve(response.data.list);
                        }
                      } else {
                        resolve(response.data.list);
                      }
                    } else {
                      reject(false);
                      this.loader.hide();
                      this.notification(
                        "An unknown error occurred",
                        "pan_tool",
                        "danger"
                      );
                    }
                  },
                  error => {
                    reject(false);
                    this.loader.hide();
                    this.notification(error.message, "clear", "danger");
                  }
                );
              });
              reqPromises.push(promiseChunk);
            }

            // Respond all promises
            Promise.all(reqPromises)
            .then((res) => {
              allRecords.list = res.flat();
              this.generateDocs(allRecords, link);
            })
            .catch(() => {
              this.loader.hide();
              this.notification("Something went wrong", "clear", "danger");
            });
          } else {
            this.$http
              .post(link.url, {
                method: link.method,
                params: link.params
              })
              .then(
                response => {
                  if (response.data) {
                    if (response.data.error) {
                      this.loader.hide();
                      this._handleErrors(response.data);
                    } else {
                      const dataOnReq = response.data;
                      const recordsExist = (Array.isArray(dataOnReq) && dataOnReq.length)
                          || (Object.keys(dataOnReq).length && dataOnReq.list && dataOnReq.list.length);
                      if (!recordsExist){
                        this.loader.hide();
                        return this.notification(
                          "No records found matching the selected filters",
                          "pan_tool",
                          "danger"
                        );
                      }
                      this.generateDocs(dataOnReq, link);
                    }
                  } else {
                    this.loader.hide();
                    this.notification(
                      "An unknown error occurred",
                      "pan_tool",
                      "danger"
                    );
                  }
                },
                error => {
                  this.loader.hide();
                  this.notification(error.message, "clear", "danger");
                }
              );
            }
          }
      },

      debtProcessedData(tableData) {
        return tableData.map(td => {
          let total_outstanding = 0;
          let duration = '';
          const assessments = td.tax_payer.entity_type_id === 1 ? td.direct_assessments : td.assessments;
          if(assessments.length){
            assessments.map(asm => total_outstanding += parseFloat(asm.total_outstanding));

            if(assessments.length > 1){
              duration = `${assessments[0].year} - ${assessments[assessments.length - 1].year}`;
            } else {
              duration = assessments[0].year;
            }
          }

          td.total_debts = total_outstanding;
          td.duration = duration;
          return td;
        });
      },

      fetchItemByCode(arr, id, idName, name) {
        const items = arr.filter(x => x[idName] === id);
        return items.length ? items[0][name] : '';
      },

      _handleErrors(response) {
        if (response.data) {
          for (let message in response.data) {
            this.notification(response.data[message][0], "pan_tool", "danger");
          }
        } else {
          if(response.code !== 'ACCESS_DENIED') {
            this.notification(response.message, "pan_tool", "danger");
          }
        }
      },

      notification(message, icon, color) {
        this.$notify({
          message: message,
          icon: icon,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: color
        });
      },
    }
  }
</script>
<style lang="css" scoped>
  .menu {
    position: relative;
    display: inline-block;
    float: right;
    margin-top: 3px;
    margin-left: 10px;
  }

  .menu-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 150px;
    overflow: auto;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 999;
  }

  .menu-content a {
    color: black;
    padding: 8px 8px;
    text-decoration: none;
    display: block;
  }

  .menu a:hover {background-color: #ddd;}

  .show {display: block;}

  .btn-menu {
    background-color: DodgerBlue !important;
  }

  /* Darker background on mouse-over */
  .btn-menu:hover {
    background-color: RoyalBlue !important;
  }
  .drp-label {
    color: #333;
    font-weight: 400;
  }

  i.fa.fa-download.fa-1.download-icon {
    font-size: 14px !important;
  }

  .download-link, .download-link i{
    background: none !important;
    color: #fff !important;
  }
  .disabledBtn {
    opacity: 0.7;
  }
</style>
